export default [
  {
    description: 'GED Escola',
    path: '/ged/gedescola',
    name: 'ged-escola',
    component: () => import('@/views/ged/gedescola/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Documento da Escola',
    parent: 'ged-escola',
    path: '/ged/gedescola/cadastro/:id?',
    name: 'ged-escola-create',
    component: () => import('@/views/ged/gedescola/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
